import AuthBgBanner from "public/images/knicks/knicks_banner_full.jpg";
import SeatMap3dPreview from "public/images/knicks/knicks_3d_venue.png";
import { howItWorks, faqs, TopNavMenuItems } from "./helpers";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import bannerImage from "public/images/knicks/knicks_banner_sep_24.jpg";
import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";

// image sizes
// featured game card image : 350x180

const config = {
  teamSchema: "knicks",
  browserTitle: "Knicks Flex",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "New York Knicks",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00045-knicks-sec",
    mapId: "main",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: false,
  inventoryType: "SECTION-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: true,
    checkoutTimerEnabled: false,
    showFrontendTotalAmount: false,
    showFrontendServiceFee: false,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "https://flex.attendevents.com/msg_flex",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/msg/my-events",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  // images
  images: {
    findGamesBannerImage: bannerImage.src,
    authBackgroundImage: AuthBgBanner.src,
    checkoutStatusPageImage: AuthBgBanner.src,
    logoImage:
      "https://ss-leagues.s3.amazonaws.com/NHL/Knicks_logo_Aug21.png?width=76&height=61",
    logoNameImage: "",
    faviconImage:
      "https://ss-leagues.s3.amazonaws.com/NHL/Knicks_logo_Aug21.png",
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  colors: {
    primary: "#003DA7",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },
    bottomBar: {
      showGameSelectionProgress: false,
    },
  },

  languages: {
    topNavMenuItems: <TopNavMenuItems />,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: null,
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutServiceNote:
      "<b>SERVICE NOTE:</b> At this time you may need to wait 24 hours between transactions to see the correct amount of Credit Available. We apologize for any inconvenience caused and assure you that we're actively resolving this issue. Thank you for your patience.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to your account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
